/**
 * CPS项目的配置项
 */

//当前环境可手动修改为：develop/trial/release, 本地会默认为local(develop)环境
let env = 'release'
const envList = {
    //本地调试(代理模式)
    local:{
        apiurl: "",
        searchShopUrl: "http://10.181.124.3:3000/alliance/cps/searchShop"
    },
    //开发环境
    develop:{
        apiurl: "https://alliance.qa.ly.com",
        searchShopUrl: "https://m.qa.ly.com/alliance/cps/searchShop/"
    },
    //预发环境
    trial: {
        apiurl: "https://alliance.t.ly.com",
        searchShopUrl: "https://m.t.ly.com/alliance/cps/searchShop/"
    },
    //生产环境
    release: {
        apiurl: "https://alliance.ly.com",
        searchShopUrl: "https://m.ly.com/alliance/cps/searchShop/"
    }
}
let currentEnv = {}
currentEnv = envList[env]
//本地调试：永远是代理模式，不然有跨域
if(process.env.NODE_ENV === "development") {
    currentEnv = envList['local']
}


//导出环境api地址
export const API_URL = currentEnv.apiurl

//导出搜索页地址
export const SEARCH_SHOP_URL = currentEnv.searchShopUrl

//导出api路径
export const API_PATHS = {
	ProductDetail:  API_URL + "/webapi/resource/detail", // 历史订单页面配置。
	ProductTarget:  API_URL + "/webapi/resource/shareTargetUrl", // 分享页面地址
    ShareInfo:  API_URL + "/webapi/alliance/share/info", // 轨迹上传
    ProductList:  API_URL + "/webapi/resource/productList", //爆款推荐
    GetShopInfo: API_URL + "/webapi/mini/shop/getShopInfo", //我的店铺信息
    GetShopItem: API_URL + "/webapi/mini/shop/getShopItem", //我的店铺信息-获取店铺列表
    GetTags: API_URL + "/webapi/resource/tagList" //获取标签
};



// WEBPACK FOOTER //
// ./src/util/cps/config.js